import ApiService from '../api.services';

const PdvDashboardService = {
    payment: async function (startedAt, finishedAt, customer) {
        try {
            const response = await ApiService.get(`/api/pdv/dashboard/payment?startedAt=${startedAt}&finishedAt=${finishedAt}&customer=${customer}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    list: async function (startedAt, finishedAt, customer, action, type) {
        try {
            const response = await ApiService.get(`/api/pdv/dashboard/call?startedAt=${startedAt}&finishedAt=${finishedAt}&customer=${customer}&action=${action}&type=${type}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    conference: async function (startedAt, finishedAt, customer) {
        try {
            const response = await ApiService.get(`/api/pdv/dashboard/conference?startedAt=${startedAt}&finishedAt=${finishedAt}&customer=${customer}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    month: async function (startedAt, finishedAt, customer) {
        try {
            const response = await ApiService.get(`/api/pdv/dashboard/month?startedAt=${startedAt}&finishedAt=${finishedAt}&customer=${customer}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    post: async function (startedAt, finishedAt, customer, action, type) {
        try {
            const response = await ApiService.get(`/api/pdv/dashboard/post?startedAt=${startedAt}&finishedAt=${finishedAt}&customer=${customer}&action=${action}&type=${type}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    timeline: async function (startedAt, userId) {
        try {
            const response = await ApiService.get(`/api/pdv/dashboard/timeline?startedAt=${startedAt}&userId=${userId}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },
    proof: async function (startedAt, userId, type = 'pdf') {
        try {
            const response = await ApiService.post(`/api/pdv/dashboard/proof?startedAt=${startedAt}&userId=${userId}&type=${type}`, {});
            return response.data;
        } catch (error) {
            throw error;
        }
    },
};

export default PdvDashboardService;

export { PdvDashboardService };

